module.exports = __webpack_public_path__ + "assets/Cannerald_Shop_Icon-Öl-Tropfen.3127b923.svg";